const OutcomeLabelOutright = {
    title: 'Example JSON',
    expectedOutput: 'Arsenal (BetOfferName)',
    initialDisplayedCode: `{
"outcomeId": 2950948551,
"betOffer": {
  "id": 883929922,
    "betOfferType": {
        "id": 4, `,
    moreCode: `"name": "BetOfferName"
    },
    "outcomes": [
        {
        "id": 2950948551,
        "label": "Arsenal",
        "type": "OT_ONE_TWO"
        },
        {
        "id": 2950948554,
        "label": "Feyenoord",
        "type": "OT_ONE_TWO"
        }
    ],
    "place": true
    },
    "event": {
      "awayName": "EventAwayName",
      "homeName": "EventHomeName"
    }
}`,
};

export default OutcomeLabelOutright;
